<template>
<div class="flex-grow">
<table class="flex-grow table-fixed w-full">
  <thead>
    <tr>
      <th class="w-1/6 px-4 py-2">
      </th>
      <th class="w-5/6 px-4 py-2"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="px-4 py-2">
        <img src="/icons/pictos_balance.png" class="w-auto">
      </td>
      <td class="flex px-4 py-2">
        <table class="flex-grow table-fixed">
          <thead>
            <tr class="bg-white-100 text-gray-700 font-light">
              <th class="w-3/6 px-4 py-2"></th>
              <th class="w-1/6"></th>
              <th class="w-1/6"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-100">
              <td class="px-4 py-2">
                  Bois
              </td>
              <td class=" px-4 py-2">{{comparisonDataset.wood}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                    Béton en blocs (parpaing)
                </td>
              <td class=" px-4 py-2">{{comparisonDataset.concrete}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                  Brique de terre cuite
                </td>
              <td class=" px-4 py-2">{{comparisonDataset.clay}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                  Béton banché
                </td>
              <td class=" px-4 py-2">{{comparisonDataset.pouredConcrete}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                  Acier
                </td>
              <td class=" px-4 py-2">{{comparisonDataset.acier}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
            <tr class="bg-gray-100">
              <td class=" px-4 py-2">
                  Aluminium
                </td>
              <td class=" px-4 py-2">{{comparisonDataset.aluminium}}</td>
              <td class=" px-4 py-2">kg eq. CO&#8322;</td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>

</div>
</template>

<script>
export default {
  name: 'ResultTableComparisons',
  props: {
    comparisonDataset: { type: Object, required: true },
  },
};
</script>
